import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-availabilities-user-list-skeleton',
  templateUrl: './availabilities-user-list-skeleton.component.html',
  styleUrls: [
    './availabilities-user-list-skeleton.component.scss',
    '../modules/custom-date-table/date-table-shared-styles.scss',
  ],
})
export class AvailabilitiesUserListSkeletonComponent {
  @Input() days: number = 1;

  getCappedDays(): number {
    return Math.min(this.days, 40);
  }
}
